import createEndpointPath from './createEndpointPath';

const ACCOUNT_CLIENT_API_ENDPOINTS = {
	ASSETS: {
		COUNTRIES: {
			LIST: createEndpointPath('/amo/api/countries/list'),
		},
		STATES: {
			LIST: createEndpointPath('/amo/api/states/list'),
		},
		QUESTION_TYPES: {
			LIST: createEndpointPath('/amo/api/question-types/list'),
		},
		RULE_SETS: {
			LIST: createEndpointPath('/amo/api/rule-sets/list'),
		},
		DOCUMENT_TYPES: {
			LIST: createEndpointPath('/amo/api/document-types/list'),
		},
	},
	AUTH: {
		LOGIN: createEndpointPath('/uma/api/v1/auth/b2c/login/basic'),
		USER_BRANCHES: createEndpointPath('/amo/api/branches/list'),
		REFRESH_TOKEN: createEndpointPath('/uma/api/v1/auth/b2c/refresh'),
		LOGOUT: createEndpointPath('/uma/api/v1/auth/b2c/logout'),
		RESET_PASSWORD: createEndpointPath('uma/api/v1/auth/b2c/reset-password'),
		RESET_PASSWORD_CODE: createEndpointPath('uma/api/v1/auth/b2c/send-reset-password-code'),
		REGISTRATION: createEndpointPath('/uma/api/v1/auth/b2c/register'),
		VERIFICATION: {
			PHONE: {
				SEND: createEndpointPath('/uma/api/v1/b2c/settings/codes'),
				VERIFY: createEndpointPath('/uma/api/v1/b2c/settings'),
			},
			EMAIL: {
				SEND: createEndpointPath('/uma/api/v1/b2c/settings/codes'),
				VERIFY: createEndpointPath('/uma/api/v1/b2c/settings'),
			},
		},
		GET_NEXT_GEN_TOKEN: createEndpointPath('auth/sso/generate-token'),
	},
	AUTH_FORMS: {
		GET_AUTH_FORM_BY_SLUG: createEndpointPath('/uma/api/v1/auth-forms/public/:slug'),
	},
	MFA: {
		GET_VERIFICATION_MFA_CODE: createEndpointPath('uma/api/v1/auth/b2c/send-mfa-code'),
		GET_MFA_METHODS: createEndpointPath('/uma/api/v1/b2c/settings/mfa-options'),
		TOGGLE_MFA: createEndpointPath('/uma/api/v1/b2c/settings'),
		TOTP: {
			GET_INITIAL_CREDS: createEndpointPath('uma/api/v1/auth-apps/totp/registration/qr'),
			ADD_TOTP_METHOD: createEndpointPath('uma/api/v1/auth-apps/totp/registration/response'),
		},
		WEBAUTHN: {
			ADD_WEB_AUTHN_METHOD: createEndpointPath('uma/api/v1/auth-apps/webauthn/registration/response'),
			GET_CREDS: createEndpointPath('uma/api/v1/auth-apps/webauthn/registration/request'),
			LOGIN_REQUEST: createEndpointPath('uma/api/v1/auth-apps/webauthn/login/request'),
		},
	},
	APPLICATIONS: {
		LIST: createEndpointPath('/amo/api/applications/list'),
		GET: createEndpointPath('/amo/api/applications/get'),
		DOWNLOAD_APPLICATION: createEndpointPath('/amo/api/applications/pdf/applicant'),
		GENERATE_SIGN_LINK: createEndpointPath('amo/api/applications/pdf/w8/generate-sign-link'),
	},
	APPLICATION_FORM: {
		CREATE: createEndpointPath('/amo/api/applications/create'),
		ANSWER: createEndpointPath('/amo/api/applications/answer'),
		DELETE_ANSWER: createEndpointPath('/amo/api/applications/delete-answer'),
		SUBMIT: createEndpointPath('/amo/api/applications/submit'),
		BACKGROUND_CHECK: createEndpointPath('/amo/api/applications/background-check'),
		VERIFY_DOCUMENTS: createEndpointPath('/amo/api/applications/verify-documents'),
		CUSTODIAN_CHECK: createEndpointPath('/amo/api/applications/custodian/send'),
	},
	FORMS: {
		GET: createEndpointPath('/amo/api/forms/get'),
		LIST: createEndpointPath('/amo/api/forms/list'),
	},
	USERS: {
		GET: createEndpointPath('/amo/api/users/get'),
		UPDATE: createEndpointPath('/uma/api/v1/b2c/settings'),
	},
	SETTINGS: {
		GET: createEndpointPath('/amo/api/settings/get'),
		SET: createEndpointPath('/amo/api/settings/set'),
	},
};

export default ACCOUNT_CLIENT_API_ENDPOINTS;
